export default "__VITE_ASSET__BStdsfGw__"